module.exports = __webpack_public_path__ + "static/media/undraw_personal_text_re_vqj3.29831b17.svg";